module.exports = __webpack_public_path__ + "static/media/NORTHERN PENINSULA AREA REGIONAL.c27604cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_areas/NORTHERN PENINSULA AREA REGIONAL.svg
// module id = 571
// module chunks = 0